export enum LocaleStorageKeysEnum {
  GLOBAL_COUPON = "global_token",
}

export const setLocalItem = <T>(key: LocaleStorageKeysEnum, value: T): void => {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error("Error saving to localStorage:", error);
  }
};

export const getLocalItem = <T>(key: LocaleStorageKeysEnum): T | null => {
  try {
    const serializedValue = localStorage.getItem(key);
    if (serializedValue === null) return null;
    return JSON.parse(serializedValue) as T;
  } catch (error) {
    console.error("Error reading from localStorage:", error);
    return null;
  }
};

export const removeLocalItem = (key: LocaleStorageKeysEnum): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing from localStorage:", error);
  }
};
